// Canonical payment-method values (mirrors the API's PaymentMethodType) mapped
// to the labels shown across donor tables, drawers, and CSV exports. Kept in
// one place so the vocabulary and casing stay consistent everywhere — notably
// acronyms like "ACH" and brand names like "PayPal" that a naive title-case
// would mangle into "Ach"/"Paypal".

const CARD_BRANDS = ['visa', 'mastercard', 'amex', 'discover', 'credit_card'];

const LABELS: Record<string, string> = {
    credit_card: 'Credit Card',
    ach: 'ACH',
    apple_pay: 'Apple Pay',
    google_pay: 'Google Pay',
    paypal: 'PayPal',
    link: 'Link',
    unknown: 'Unknown',
};

export const formatPaymentSource = (method?: string | null): string => {
    // An empty value predates payment-method classification; treat it as the
    // most common source rather than showing a blank.
    if (!method) return 'Credit Card';
    const key = method.toLowerCase();
    // Legacy rows may still store a specific brand; collapse it to the category.
    if (CARD_BRANDS.includes(key)) return 'Credit Card';
    if (LABELS[key]) return LABELS[key];
    // Fallback for anything unmapped: title-case with spaces.
    return method.charAt(0).toUpperCase() + method.slice(1).replace(/_/g, ' ');
};
